import { useEffect } from 'react'
import { useUIStore, applyResolvedTheme, type ThemeMode } from '../store/ui'

/**
 * Hook to manage theme mode and palette. Applies the current theme to the DOM
 * and provides setters for both mode and palette id.
 */
export function useTheme() {
  const themeMode = useUIStore((s) => s.themeMode)
  const themeId = useUIStore((s) => s.themeId)
  const setThemeMode = useUIStore((s) => s.setThemeMode)
  const setThemeId = useUIStore((s) => s.setThemeId)

  // Re-apply on mount in case the store rehydrated after the initial render.
  useEffect(() => {
    applyResolvedTheme(themeId, themeMode)
  }, [themeId, themeMode])

  return { themeMode, themeId, setThemeMode, setThemeId }
}

// Re-export for call sites that still use `Theme`
export type { ThemeMode }
/** @deprecated use ThemeMode */
export type Theme = ThemeMode
